import { render, staticRenderFns } from "./BaseReCaptcha.vue?vue&type=template&id=67fe6174&scoped=true&"
import script from "./BaseReCaptcha.vue?vue&type=script&lang=js&"
export * from "./BaseReCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./BaseReCaptcha.vue?vue&type=style&index=0&id=67fe6174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe6174",
  null
  
)

export default component.exports